import { useTranslation } from "react-i18next";
import { useAxios } from "../useAxios";
import { useQuery } from "@tanstack/react-query";
import { LevelCParticipantCompetencyPointsResponse, LevelCReportFilter } from "../../types/levelc-reports";

interface UseGetLevelCParticipantCompetencyPointsParams {
  filter: LevelCReportFilter;
  enabled?: boolean;
}

export const useGetLevelCParticipantCompetencyPoints = ({
  filter,
  enabled = true,
}: UseGetLevelCParticipantCompetencyPointsParams) => {
  const axios = useAxios();
  const { t } = useTranslation();

  const fetchParticipantCompetencyPoints = async (): Promise<LevelCParticipantCompetencyPointsResponse> => {
    try {
      const params = new URLSearchParams({
        startDate: filter.startDate,
        endDate: filter.endDate,
      });

      if (filter.examTermId) {
        params.append('examTermId', filter.examTermId);
      }

      const { data } = await axios.get(`/api/levelcreports/participant-competency-points?${params.toString()}`);
      return data;
    } catch (error) {
      throw new Error(t("levelCReports.errors.getParticipantCompetencyPoints"));
    }
  };

  return useQuery({
    queryKey: ["levelCParticipantCompetencyPoints", filter],
    queryFn: fetchParticipantCompetencyPoints,
    enabled: enabled && Boolean(filter.startDate) && Boolean(filter.endDate) && Boolean(filter.examTermId),
  });
};

